import { render, staticRenderFns } from "./ProductLowCost.vue?vue&type=template&id=9590e8a2&scoped=true&"
import script from "./ProductLowCost.vue?vue&type=script&lang=js&"
export * from "./ProductLowCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9590e8a2",
  null
  
)

export default component.exports